import { get, writable } from 'svelte/store'

const store = writable<string>('')

export default {
  subscribe: store.subscribe,
  set: (slugReplacement: string) => store.set(slugReplacement),
  get: () => get(store),
}
